<script lang="ts">
  import { MixLayout } from "../../utils/Constant/Constant";
  import CommenUl from "./CommenUl.svelte";
  import {isDarkMode} from "../../store"
  let selectClass:string
  const handleLayout = (getClass:string) => {
    selectClass = getClass
    if (getClass === 'light-only') {
            document.body.classList.add('light-only');
            document.body.classList.remove('dark-sidebar');
            document.body.classList.remove('dark-only');
    } else if (getClass === 'dark-sidebar') {
            document.body.classList.remove('light-only');
            document.body.classList.add('dark-sidebar');
            document.body.classList.remove('dark-only');
    } else if (getClass === 'dark-only') {
            document.body.classList.remove('light-only');
            document.body.classList.remove('dark-sidebar');
            document.body.classList.add('dark-only');
            isDarkMode.update(value => value = true) 
    }
  }

</script>
<h6>{MixLayout}</h6>
<ul class= 'layout-grid customizer-mix'>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li  class= 'color-layout {selectClass === 'light-only' ? "active" : ""}' on:click={()=>handleLayout('light-only')} >
        <div class="header bg-light" >
            <CommenUl />
        </div>
        <div class="body">
            <ul>
                <li class= 'bg-light sidebar'></li>
                <li class= 'bg-light body'> </li>
            </ul>
        </div>
    </li>
     <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class= 'color-layout {selectClass === 'dark-sidebar' ? "active" : ""}' on:click={()=>handleLayout('dark-sidebar')} >
        <div class="header bg-light">
            <CommenUl />
        </div>
        <div class="body">
            <ul>
                <li class= 'bg-dark sidebar'></li>
                <li class= 'bg-light body' > </li>
            </ul>
        </div>
    </li>
     <!-- svelte-ignore a11y-click-events-have-key-events -->
    <li class= 'color-layout {selectClass === 'dark-only' ? "active" : ""}' on:click={()=>handleLayout('dark-only')} >
        <div class="header bg-dark">
            <CommenUl />
        </div>
        <div class="body">
            <ul>
                <li class= 'bg-dark sidebar'></li>
                <li  class= 'bg-dark body'> </li>
            </ul>
        </div>
    </li>
</ul>